/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
const first_aid = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M8 7.487v2m0 2v-2m0 0H6m2 0h2M5 4.5H3a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2h-2m-6 0v-2a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2m-6 0h6"
    />
  </svg>
)
export default first_aid
